document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.scattered-parallax-wrapper');
    const images = section.querySelectorAll('.scattered-parallax-image');
    const title = section.querySelector('.scattered-parallax-title');
    let isInView = false;

    // Apply responsive image styles
    const applyResponsiveStyles = (el) => {
        const isMobile = window.innerWidth < 768;

        el.style.top = isMobile
            ? `${el.dataset.topMobile}%`
            : `${el.dataset.topDesktop}%`;

        el.style.left = isMobile
            ? `${el.dataset.leftMobile}%`
            : `${el.dataset.leftDesktop}%`;
            
        el.style.width = isMobile
            ? `${el.dataset.widthMobile}vw`
            : `${el.dataset.widthDesktop}vh`;

        el.style.height = isMobile
            ? `${el.dataset.heightMobile}vw`
            : `${el.dataset.heightDesktop}vh`;
    };

    // Apply responsive line-height to title
    const applyResponsiveLineHeight = () => {
      if (!title) return;
      const isMobile = window.innerWidth < 768;
      const lineHeight = isMobile
        ? title.dataset.lineHeightMobile
        : title.dataset.lineHeightDesktop;

      title.style.lineHeight = `${lineHeight}`;
    };

    // Initial setup
    images.forEach(applyResponsiveStyles);
    applyResponsiveLineHeight();

    // Re-apply on window resize
    window.addEventListener('resize', () => {
      images.forEach(applyResponsiveStyles);
      applyResponsiveLineHeight();
    });

    // Setup scroll observer for parallax
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isInView = entry.isIntersecting;
      });
    }, { threshold: 0.1 });

    observer.observe(section);

    // Scroll-based parallax
    let ticking = false;

    window.addEventListener('scroll', () => {
        if (!isInView || ticking) return;

        ticking = true;
        requestAnimationFrame(() => {
            const sectionTop = section.getBoundingClientRect().top;
            const scrollY = -sectionTop;
            const isMobile = window.innerWidth < 768;

            images.forEach(el => {
            const speed = parseFloat(isMobile ? el.dataset.speedMobile : el.dataset.speedDesktop);
            const direction = isMobile ? el.dataset.directionMobile : el.dataset.directionDesktop;

            let x = 0, y = 0;
            switch (direction) {
                case 'up': y = scrollY * -speed; break;
                case 'down': y = scrollY * speed; break;
                case 'left': x = scrollY * -speed; break;
                case 'right': x = scrollY * speed; break;
            }

            const drift = parseFloat(el.dataset.drift);
            el.style.transform = `translate3d(${x + drift}px, ${y}px, 0)`;
            });

            ticking = false;
        });
    });
  });